<template>
  <el-card class="ml-2">
    <el-row>
      <el-col>

        <div class="d-inline-flex  flex-row" v-for="(item,key)_ in statusList" :key="key">
          <processo-status-icon class="p-2" :status="item">{{item.label}}</processo-status-icon>
        </div>

      </el-col>
      <el-col>
        <table class="table table-striped">
          <thead>
          <tr>
            <th>#</th>
            <th>Processo</th>
            <th>Centro Custo</th>
            <th>Data</th>
            <th>
              <el-button icon="el-icon-refresh"
                         type="warning"
                         size="mini"
                         circle
                         @click="$emit('clickRefresh')">
              </el-button>
            </th>
          </tr>
          </thead>
          <tbody>

          <template v-for="processo in list" >
            <tr :key="processo.id" >
              <td>{{processo.id}}</td>
              <td>{{processo.nome}}</td>
              <td>{{processo.centro_custo_nome}}</td>
              <td>{{processo.created_at}}</td>
              <td align="center">   
                <processo-status-icon :status="statusList[processo.status]"></processo-status-icon>
              </td>
            </tr>
            <tr v-if="processo.error" class="table-danger">
              <td colspan="5"> {{processo.id}} - {{processo.error}}</td>
            </tr>
          </template>

          </tbody>
        </table>
      </el-col>
    </el-row>

  </el-card>
</template>

<script>
  import ProcessoStatusIcon from "./ProcessoStatusIcon";

  export default {
    name: "ProcessoList",
    components: {ProcessoStatusIcon},
    props: ['list'],
    data() {
      return {
        statusList: {
          0: {icon: "icon-control-pause", color: "#e0a800", label: 'Não Executado'},
          1: {icon: "icon-refresh", color: "#0e6498", label: 'Executando'},
          2: {icon: "icon-check", color: "#00a67c", label: 'Executado'},
          3: {icon: "icon-close", color: "#9f191f", label: 'Error'}
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Competencia/ProcessoList.vue